import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

const ExploreStatesSection = () => {
  const [states, setStates] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await api.get("/states");
        setStates(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Failed to fetch states:", error);
        setStates([]);
      }
    };

    fetchStates();
  }, []);

  const getStateLogo = (state) => {
    const name = state?.state_name?.toLowerCase()?.trim();
    const isWikipedia = state?.party_logo?.includes("wikipedia");

    if (name === "bihar" && (!state.party_logo || isWikipedia)) {
      return "/state-logos/bihar.png";
    }

    return state?.party_logo || "/party-logos/party.png";
  };

  return (
    <section className="py-16 bg-gradient-to-b from-orange-50 via-white to-green-50">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h2 className="text-4xl font-bold text-orange-700 mb-6 drop-shadow-sm">
          Explore Indian States and UTs
        </h2>
        <p className="text-gray-700 mb-10 max-w-2xl mx-auto">
          Find the current chief minister, ruling party, and loaded MP and MLA data for every state page.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
          {states.map((state, index) => (
            <motion.div
              key={`${state.state_name}-${index}`}
              whileHover={{ scale: 1.05 }}
              className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-lg transition p-4 cursor-pointer"
              onClick={() => navigate(`/state/${state.state_name}`)}
            >
              <img
                src={getStateLogo(state)}
                alt={state.state_name}
                className="w-12 h-12 mx-auto mb-2"
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src = "/party-logos/party.png";
                }}
              />
              <h3 className="text-lg font-semibold text-gray-800">{state.state_name}</h3>
              <p className="text-sm text-gray-600 mt-1">CM: {state.cm?.name || "Not available"}</p>
              <p className="text-sm text-gray-500 mt-1">{state.ruling_party || "Party not available"}</p>
              <p className="text-xs text-gray-400 mt-1">
                MP: {state.mps?.length || 0} | MLA: {state.mlas?.length || 0}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExploreStatesSection;
